export default __webpack_public_path__ + "static/SRUS P285 - Especification Del Producto y Datos Técnicos-67df9a441933a6590dfdfaca41ee340e.pdf";